var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-title-wrapper"},[_c('h2',{class:['section-title', { 'xl': _vm.xl }],attrs:{"id":_vm.id},domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }